export default "__VITE_ASSET__CEqMHs_n__"